var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMail = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.00012 3.99998H20.0001C21.1001 3.99998 22.0001 4.89998 22.0001 5.99998V18C22.0001 19.1 21.1001 20 20.0001 20H4.00012C2.90012 20 2.00012 19.1 2.00012 18V5.99998C2.00012 4.89998 2.90012 3.99998 4.00012 3.99998Z",
  stroke: "#5E6C84",
  strokeWidth: 1.99861,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0001 6.00008L12.0001 13.0001L2.00012 6.00008",
  stroke: "#5E6C84",
  strokeWidth: 1.99861,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail.08d2d53b.svg";
export { ForwardRef as ReactComponent };